import htmlDocx from 'html-docx-js/dist/html-docx';

// Function to export HTML content to Word (.docx)
export const exportToWord = (content, fileName = "policy.docx") => {
  // Convert the HTML content to a Word document
  const converted = htmlDocx.asBlob(content);

  // Create a link element to trigger the download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(converted);
  link.download = fileName;
  link.click();
};
